import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { abTestState } from '../recoil/atoms';
import { ProductHandle } from '../enums/ProductHandle.enum';
import { ViewProduct } from '../models/ViewProduct.model';
import { HoneyloveAbTests } from '../models/HoneyloveAbTests';

export interface PossibleStyle {
  title: string;
  handle: ProductHandle;
}

const mainStyles: PossibleStyle[] = [
  { title: 'Short', handle: ProductHandle.SuperPowerShort },
  { title: 'Brief', handle: ProductHandle.SuperPowerBrief },
  { title: 'Thong', handle: ProductHandle.SuperPowerThong },
];

const tankStyles: PossibleStyle[] = [
  { title: 'Wide straps', handle: ProductHandle.LiftWearTank },
  { title: 'Adjustable straps', handle: ProductHandle.LiftWearCami },
];

const braStyles: PossibleStyle[] = [
  { title: 'Crossover', handle: ProductHandle.CrossoverBra },
  { title: 'Silhouette', handle: ProductHandle.SilhouetteBra },
  { title: 'V-Neck', handle: ProductHandle.VNeckBra },
];

const tankBodysuitStyles: PossibleStyle[] = [
  { title: 'Wide straps', handle: ProductHandle.TankBodysuit },
  { title: 'Adjustable straps', handle: ProductHandle.CamiBodysuit },
];

const tankBodysuitStylesTest: PossibleStyle[] = [
  { title: 'Tank', handle: ProductHandle.LiftWearTank },
  { title: 'Tank Bodysuit', handle: ProductHandle.TankBodysuit },
  { title: 'Cami', handle: ProductHandle.LiftWearCami },
  { title: 'Cami bodysuit', handle: ProductHandle.CamiBodysuit },
];

const styleGroup = (handle: ProductHandle, abTests: HoneyloveAbTests): PossibleStyle[] => {
  if (
    abTests['AB2022-12'] &&
    [ProductHandle.LiftWearTank, ProductHandle.LiftWearCami, ProductHandle.CamiBodysuit, ProductHandle.TankBodysuit].includes(handle)
  ) {
    return tankBodysuitStylesTest;
  } else if (abTests['AB2022-13'] && [ProductHandle.CrossoverBra, ProductHandle.SilhouetteBra, ProductHandle.VNeckBra].includes(handle)) {
    return braStyles;
  }
  switch (handle) {
    case ProductHandle.SuperPowerShort:
    case ProductHandle.SuperPowerBrief:
    case ProductHandle.SuperPowerThong:
      return mainStyles;
    case ProductHandle.LiftWearTank:
    case ProductHandle.LiftWearCami:
      return tankStyles;
    case ProductHandle.CamiBodysuit:
    case ProductHandle.TankBodysuit:
      return tankBodysuitStyles;
    default:
      return [];
  }
};

export const useProductStyles = ({ handle }: ViewProduct): PossibleStyle[] => {
  const [styles, setStyles] = useState<PossibleStyle[]>([]);
  const abTests = useRecoilValue(abTestState);

  const handleSorter = (a: PossibleStyle, b: PossibleStyle) => {
    switch (true) {
      case a.handle === handle:
        return -1;
      case b.handle === handle:
        return 1;
      default:
        return 0;
    }
  };

  const groupChanged = (newStyles: PossibleStyle[]) => !(styles.length === newStyles.length && styles.every((style) => newStyles.includes(style)));

  const possibleStyles = styleGroup(handle, abTests);
  const didGroupChange = groupChanged(possibleStyles);
  if (didGroupChange) {
    const sortedStyles = possibleStyles.sort(handleSorter);
    setStyles(sortedStyles);
    return sortedStyles;
  }

  return styles;
};
